import { Outlet } from 'react-router';
import { type CSSProperties, useState } from 'react';
import { HeaderComponent } from '@/cleanapi/Header.tsx';
import { WithoutOrganizationComponent } from '@/cleanapi/WithoutOrganizationComponent.tsx';
import type { CurrentUser, CurrentUserLoader } from '@/cleanapi/CurrentUser.ts';
import { LoaderComponent, useLoader } from '@/generic/loader';
import { initAccount } from '@/supporting/account';
import { DiagnosticTrackingProvider, DiagnosticTrackingToastComponent } from '@/diagnostic';
import {
  RuleExtractionTrackingProvider,
  RuleExtractionTrackingToastComponent,
} from '@/rules-management';

const toastStackStyle: CSSProperties = {
  position: 'fixed',
  bottom: 24,
  right: 24,
  zIndex: 100,
  display: 'flex',
  flexDirection: 'column-reverse',
  gap: 16,
};

const onCurrentUserChecking = () => <></>;

const onCurrentUserFailure = () => <Outlet />;

const onCurrentUser = (currentUser: CurrentUser) =>
  currentUser.fold({
    error: () => <WithoutOrganizationComponent />,
    success: () => <Outlet />,
  });

const ApplicationComponent = ({ currentUser }: { currentUser: CurrentUserLoader }) => (
  <LoaderComponent
    loader={currentUser}
    onLoading={onCurrentUserChecking}
    onError={onCurrentUserFailure}
    onSuccess={onCurrentUser}
  />
);

export const Layout = () => {
  const [version, setVersion] = useState(0);

  const { injectUsersRepository } = initAccount();

  const currentUser: CurrentUserLoader = useLoader(
    () => injectUsersRepository().currentUser(),
    [version],
  );

  const refreshCurrentUser = () => setVersion((current) => current + 1);

  return (
    <DiagnosticTrackingProvider>
      <RuleExtractionTrackingProvider>
        <div className="ippon-layout">
          <header className="ippon-layout--header">
            <HeaderComponent currentUser={currentUser} onRefreshCurrentUser={refreshCurrentUser} />
          </header>
          <main className="ippon-layout--body">
            <ApplicationComponent currentUser={currentUser} />
          </main>
          <div style={toastStackStyle}>
            <DiagnosticTrackingToastComponent />
            <RuleExtractionTrackingToastComponent />
          </div>
        </div>
      </RuleExtractionTrackingProvider>
    </DiagnosticTrackingProvider>
  );
};
